export const URL_MOVIE = 1;
export const URL_TV_CHANEL = 2;
export const URL_TV_SHOW = 3;
export const URL_SPORTS = 4;
export const URL_OTHER = 5;


// WEBPACK FOOTER //
// ./src/constants/UrlByTypeCategories.js